// Los tres roles de MiPAE (decisión del fundador 2026-10-03, implementada el
// 2026-10-04, plan en docs/plan-tres-roles.md): MiPAE estudiante, MiPAE
// enfermero y MiPAE TENS. Fuente ÚNICA del catálogo: antes vivía copiado en
// Perfil.jsx, OnboardingAgente.jsx y onboardingAgente.js, más etiquetas
// sueltas en el panel de usuario y en admin, y cada copia decía otra cosa.
//
// El internado NO es un rol: es la etapa del estudiante (`etapa_internado`).
// Docencia y postgrado caen en enfermero; "explorando" y el valor legado
// "interno" caen en estudiante. La BD tiene CHECK de catálogo con estos tres
// valores y un trigger que traduce lo que todavía mande la app instalada vieja
// (migración 20261004120000_tres_roles.sql). No confundir con `profiles.role`
// (intern/admin/owner), que es el eje de autorización.

// Orden = orden del selector. "o interno/a" en la etiqueta a propósito
// (recorrido de claridad 2026-09-03): el interno no se encontraba bajo
// "Estudiante" y la pregunta siguiente lo distingue por etapa. La descripción
// del enfermero nombra docencia y postgrado para que una docente sepa dónde
// caer sin inventarle un rol.
export const ROLES = Object.freeze([
  { value: 'estudiante', label: 'Estudiante o interno/a de enfermería', desc: 'Pregrado, práctica o internado' },
  { value: 'enfermero',  label: 'Enfermero/a',                          desc: 'En ejercicio profesional, docencia o postgrado' },
  { value: 'tens',       label: 'TENS',                                 desc: 'Técnico/a en enfermería, en ejercicio' },
]);

export const ROLES_VALIDOS = Object.freeze(ROLES.map((r) => r.value));

// Etiqueta completa (la del selector) y corta (admin, lugares estrechos).
export const ROL_LABEL = Object.freeze(Object.fromEntries(ROLES.map((r) => [r.value, r.label])));
export const ROL_CORTO = Object.freeze({ estudiante: 'Estudiante', enfermero: 'Enfermero/a', tens: 'TENS' });

/**
 * Nombre del rol para mostrar. Un valor fuera del catálogo (un histórico que
 * todavía lo traiga) se devuelve crudo en vez de inventarle una etiqueta, y
 * sin rol devuelve null.
 * @param {string|null|undefined} rol
 * @param {{corto?: boolean}} [opciones]
 * @returns {string|null}
 */
export function etiquetaRol(rol, { corto = false } = {}) {
  if (!rol) return null;
  const mapa = corto ? ROL_CORTO : ROL_LABEL;
  return mapa[rol] ?? String(rol);
}
